<form [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
  <div class="grid grid-cols-1 gap-5 md:grid-cols-1">
    <div [ngClass]="form.controls['title'].touched ? (form.controls['title'].errors ? 'has-error' : 'has-success') : ''">
      <label for="title">{{ "tax_categories.title" | translate }}</label>
      <input type="text" placeholder="{{ 'tax_categories.enter_title' | translate }}" class="form-input" id="title" formControlName="title" maxlength="60" #nameInput />
      <ng-container *ngIf="form.controls['title'].touched && form.controls['title'].errors">
        <p class="mt-1 text-danger">
          <small>{{ "tax_categories.please_provide_title" | translate }}</small>
        </p>
      </ng-container>
    </div>

    <div [ngClass]="form.controls['category'].touched ? (form.controls['category'].errors ? 'has-error' : 'has-success') : ''">
      <label for="category">{{ "tax_categories.category" | translate }}</label>
      <ng-select
        [placeholder]="'tax_categories.enter_category' | translate"
        [items]="taxCategoriesOptions"
        [searchable]="false"
        [clearable]="true"
        formControlName="category"
        (change)="setReasonsByCategory($event)"
        [tabFocusOnClearButton]="false"
      >
      </ng-select>
      <ng-container *ngIf="form.controls['category'].touched && form.controls['category'].errors">
        <p class="mt-1 text-danger">
          <small>{{ "tax_categories.please_provide_category" | translate }}</small>
        </p>
      </ng-container>
    </div>

    <div [ngClass]="form.controls['percentage'].touched ? (form.controls['percentage'].errors ? 'has-error' : 'has-success') : ''">
      <label for="percentage">{{ "tax_categories.percentage" | translate }}</label>
      <div class="flex">
        <input
          type="text"
          readonly
          placeholder="{{ 'tax_categories.enter_percentage' | translate }}"
          class="form-input flex-1 ltr:rounded-l-md ltr:rounded-r-none rtl:rounded-r-none rtl:border-l-0"
          id="percentage"
          formControlName="percentage"
          #nameInput
        />
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
        >
          %
        </div>
      </div>
      <ng-container *ngIf="form.controls['percentage'].touched && form.controls['percentage'].errors">
        <p class="mt-1 text-danger">
          <small>{{ "tax_categories.please_provide_percentage" | translate }}</small>
        </p>
      </ng-container>
    </div>

    <div
      class="inline-flex cursor-pointer items-center space-x-1 rounded-md border border-green-500 bg-white px-3 py-1.5 text-sm font-medium text-green-600 shadow-sm transition hover:bg-green-50"
      (click)="showTaxForm = !showTaxForm"
    >
      <ng-container *ngIf="!showTaxForm; else closeIcon">
        <icon-plus class="text-sm"></icon-plus>
        <span *ngIf="!edit">{{ "e-invoice_sales.tax_categories.add_base_exemption" | translate }}</span>
        <span *ngIf="edit">{{ "e-invoice_sales.tax_categories.base_exemption" | translate }}</span>
      </ng-container>

      <ng-template #closeIcon>
        <icon-x class="text-sm"></icon-x>
        <span>{{ "e-invoice_sales.tax_categories.base_exemption" | translate }}</span>
      </ng-template>
    </div>

    <div [ngClass]="form.controls['code'].touched ? (form.controls['code'].errors ? 'has-error' : 'has-success') : ''" *ngIf="showTaxForm">
      <label for="code">{{ "tax_categories.code" | translate }}</label>
      <ng-select [items]="filteredReasons" bindLabel="key" bindValue="key" [searchable]="true" [clearable]="true" formControlName="code" [tabFocusOnClearButton]="false"> </ng-select>
      <ng-container *ngIf="form.controls['code'].touched && form.controls['code'].errors">
        <p class="mt-1 text-danger">
          <small>{{ "tax_categories.please_provide_code" | translate }}</small>
        </p>
      </ng-container>
    </div>

    <div [ngClass]="form.controls['desicionNumber'].touched ? (form.controls['desicionNumber'].errors ? 'has-error' : 'has-success') : ''" *ngIf="showTaxForm">
      <label for="desicionNumber">{{ "tax_categories.desicionNumber" | translate }}</label>
      <input type="text" placeholder="{{ 'tax_categories.enter_desicionNumber' | translate }}" class="form-input" id="desicionNumber" formControlName="desicionNumber" maxlength="60" #nameInput />
      <ng-container *ngIf="form.controls['desicionNumber'].touched && form.controls['desicionNumber'].errors">
        <p class="mt-1 text-danger">
          <small>{{ "tax_categories.please_provide_desicionNumber" | translate }}</small>
        </p>
      </ng-container>
    </div>

    <div [ngClass]="form.controls['description'].touched ? (form.controls['description'].errors ? 'has-error' : 'has-success') : ''" *ngIf="showTaxForm">
      <label for="description">{{ "tax_categories.description" | translate }}</label>
      <input type="text" placeholder="{{ 'tax_categories.enter_description' | translate }}" class="form-input" id="description" formControlName="description" maxlength="60" #nameInput />
      <ng-container *ngIf="form.controls['description'].touched && form.controls['description'].errors">
        <p class="mt-1 text-danger">
          <small>{{ "tax_categories.please_provide_description" | translate }}</small>
        </p>
      </ng-container>
    </div>

    <button type="submit" class="btn btn-primary mt-3 w-full" [disabled]="isLoading || form.invalid">
      <ng-container *ngIf="isLoading; else alternateTranslation">
        <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
        {{ "loading" | translate }}
      </ng-container>
      <ng-template #alternateTranslation>
        <span *ngIf="!edit">{{ "save" | translate }}</span>
        <span *ngIf="edit">{{ "edit_quick_label" | translate }}</span>
      </ng-template>
    </button>
  </div>
</form>
